module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "box d-flex justify-content-between"
  }, [_c('section', {
    staticClass: "d-flex grow-1 align-items-center"
  }, [(!_vm.editing) ? _c('a', {
    attrs: {
      "href": _vm.url,
      "target": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "mr-4 grow-1",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.update(_vm.id)
      }
    }
  }, [(_vm.editing) ? _c('input', {
    directives: [{
      name: "select",
      rawName: "v-select"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input file-name-input grow-1",
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "d-flex flex-column"
  }, [(_vm.editing) ? _c('input', {
    staticClass: "button is-small",
    attrs: {
      "type": "button",
      "value": "cancel",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('button', {
    staticClass: "button is-small is-success",
    class: _vm.updating && 'is-loading',
    attrs: {
      "type": "button",
      "value": "save"
    },
    on: {
      "click": function($event) {
        _vm.update(_vm.id, _vm.name)
      }
    }
  }, [_vm._v("\n      save\n    ")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('input', {
    staticClass: "button is-small is-danger",
    attrs: {
      "type": "button",
      "value": "delete",
      "name": "delete"
    },
    on: {
      "click": function($event) {
        _vm.showDelete = !_vm.showDelete
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('input', {
    staticClass: "button is-small",
    attrs: {
      "type": "button",
      "value": "edit",
      "name": "edit"
    },
    on: {
      "click": function($event) {
        _vm.editing = true
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "button is-small is-info",
    attrs: {
      "type": "button",
      "value": "make a copy",
      "name": "make a copy"
    },
    on: {
      "click": function($event) {
        _vm.showAdd = !_vm.showAdd
      }
    }
  })]), _vm._v(" "), _c('Confirm', {
    attrs: {
      "title": "Deleting File",
      "message": "Are you sure you want to delete the file?",
      "show": _vm.showDelete,
      "loading": _vm.deleting
    },
    on: {
      "cancel": function($event) {
        _vm.showDelete = false
      },
      "confirm": function($event) {
        _vm.remove(_vm.id)
      }
    }
  }), _vm._v(" "), (_vm.showAdd) ? _c('AddtoVideoModal', {
    attrs: {
      "resource": _vm.id
    },
    on: {
      "close": function($event) {
        _vm.showAdd = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-6ef36828"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileResource.vue
// module id = 1064
// module chunks = 0